import shyLogo from "../../assets/icons/shy-logo.svg";
import PortalNav from "./PortalNav";
import getClassName from "../../utilities/getClassName";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import toggleIcon from "../../assets/icons/header-toggle.svg";

const PortalHeader = ({ classNames, altHeader2 }) => {
    const [showNav, setShowNav] = useState(false);
    const [navScrolled, setNavScrolled] = useState(false);

    // The portal homepage keeps the expandable (scroll-driven) header; every other
    // portal page uses the always-collapsed header.
    const { pathname } = useLocation();
    const isHome = pathname === "/portal" || pathname === "/portal/";

    useEffect(() => {
        if (!isHome) return undefined;
        const handleScroll = () => setNavScrolled(window.scrollY > 0);
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isHome]);

    // Collapse always, except on the homepage where it follows scroll position.
    const collapsed = isHome ? navScrolled : true;

    let className = ["header"];
    if (collapsed) {
        className.push("header--scrolled");
    }

    if (typeof classNames === "object") {
        className = className.concat(classNames);
    }

    // Login panel and powered-by header logic removed as it's unused in the current implementation.
    return (
        <>
            <header className={getClassName(className)}>
                <div className="wrap header__wrap">
                    <Link to="/portal">
                        <img
                            className={getClassName(["header__logo", altHeader2 && "header__logo--on-top"])}
                            src={shyLogo}
                            alt={`${"SHY"} Logo`}
                        />
                    </Link>

                    <button
                        type="button"
                        className="header__toggle"
                        onClick={() => setShowNav(true)}
                        aria-label="Open menu"
                        aria-expanded={showNav}
                        aria-haspopup="true"
                    >
                        <img src={toggleIcon} alt="" />
                    </button>
                </div>
            </header>

            {/* {authCtx.token &&
                <ProfilePanel
                    closePanel={() => setShowProfile(false)}
                    showPanel={showProfile}
                />
            } */}

            <PortalNav closeNav={() => setShowNav(false)} showNav={showNav} />

            {/* <Modal
                classNames={['modal__content--thin']}
                modalVisible={showLoginPanel}
                closeModal={closeLoginPanel}
            >
                <LoginForgotPasswordSteps
                    closePanel={closeLoginPanel}
                />
            </Modal> */}
        </>
    );
};

export default PortalHeader;
